export default {
    getActivityOfferedComponents: { method: 'get', url: 'activity_offered_components' },
    postActivityOfferedComponent: { method: 'post', url: 'activity_offered_components' },
    putActivityOfferedComponent: { method: 'put', url: 'activity_offered_components/{id}' },
    deleteActivityOfferedComponent: { method: 'delete', url: 'activity_offered_components/{id}' },
}
